// extracted by mini-css-extract-plugin
module.exports = {"lia-separator":"LoginForm_lia-separator__2N9OA"};